import type { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { authConfig, authEnabled } from './config';

// Wraps the app in Auth0Provider when configured; otherwise a transparent
// passthrough so local dev runs without any Auth0 tenant.
export function AuthProvider({ children }: { children: ReactNode }) {
  if (!authEnabled) return <>{children}</>;

  return (
    <Auth0Provider
      domain={authConfig.domain}
      clientId={authConfig.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        ...(authConfig.audience ? { audience: authConfig.audience } : {}),
      }}
      cacheLocation="localstorage"
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
}
